// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"9":"b6c9b8dc","60":"4e0f7ed2","562":"0326b9e9","828":"4cf51886","833":"d82f9a1c","864":"4e0f7ed2"}[chunkId] + ".css";
};